import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function HistoricMoments() {
  const {
    t
  } = useLanguage();
  const moments = [{
    title: t('history.wc2014'),
    year: '2014',
    videoId: 'ffAYByv2pLc',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.bestGoals'),
    year: '1954-2022',
    videoId: 'FqvCoMeiztk',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.wc1990'),
    year: '1990',
    videoId: 'hu1meVUoIKQ',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.bern1954'),
    year: '1954',
    videoId: '5cVrWymwsRg',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.euro1996'),
    year: '1996',
    videoId: 'arrPEu7CNhE',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.wc1974'),
    year: '1974',
    videoId: 'sjf7KEyUZMM',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.kloseGoals'),
    year: '2002-2014',
    videoId: 'DrAkH2dSozQ',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.mineirazo'),
    year: '2014',
    videoId: 'a7IMPsyQg6k',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.gerdMuller'),
    year: '1970-1974',
    videoId: 'uwso2zKCpz4',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.neuerSaves'),
    year: '2010-2022',
    videoId: 'JTWm4S0HukE',
    colSpan: 'md:col-span-1'
  }];
  return <section className="py-12 md:py-24 bg-germany-black" data-id="element-176">
      <div className="container mx-auto px-6 md:px-12" data-id="element-177">
        {/* Platinum accent line */}
        <div className="w-20 h-[2px] bg-gradient-to-r from-germany-platinum to-germany-platinum/0 mb-8 md:mb-12" data-id="element-178"></div>
        <div className="mb-8 md:mb-12" data-id="element-179">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-germany-platinum font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-180">
            {t('history.label')}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-oswald font-bold uppercase" data-id="element-181">
            {t('history.title1')}{' '}
            <span className="text-germany-gold" data-id="element-182">{t('history.title2')}</span>
          </motion.h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-183">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-2xl overflow-hidden aspect-video md:aspect-auto bg-[#111] border border-germany-platinum/10 hover:border-germany-platinum/30 transition-colors duration-300 ${moment.colSpan} ${moment.colSpan === 'md:col-span-2' ? 'md:h-[400px]' : 'md:h-[400px]'}`} data-id="element-184">
              <a href={`https://www.youtube.com/watch?v=${moment.videoId}`} target="_blank" rel="noopener noreferrer" className="absolute inset-0 w-full h-full group cursor-pointer block" data-id="element-185">
                <img src={`https://img.youtube.com/vi/${moment.videoId}/maxresdefault.jpg`} alt={moment.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-186" />
                <div className="absolute inset-0 bg-gradient-to-t from-germany-black via-germany-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-187"></div>
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center transition-transform duration-300 transform group-hover:scale-110" data-id="element-188">
                  <div className="w-16 h-16 bg-germany-red/90 rounded-full flex items-center justify-center backdrop-blur-sm shadow-[0_0_30px_rgba(221,0,0,0.5)]" data-id="element-189">
                    <Play className="text-white ml-1" size={24} fill="currentColor" data-id="element-190" />
                  </div>
                </div>
                {/* YouTube badge */}
                <div className="absolute top-4 right-4 bg-[#FF0000] text-white text-[10px] font-oswald uppercase tracking-widest px-2 py-1 rounded flex items-center gap-1 z-10" data-id="element-191">
                  <Play size={10} fill="currentColor" data-id="element-192" /> YouTube
                </div>
                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 md:p-8" data-id="element-193">
                  <span className="inline-block bg-germany-platinum text-germany-black text-xs font-oswald uppercase tracking-widest px-2 py-1 rounded mb-3 font-bold" data-id="element-194">
                    {moment.year}
                  </span>
                  <h4 className="font-oswald text-xl md:text-3xl font-bold uppercase text-white drop-shadow-lg" data-id="element-195">
                    {moment.title}
                  </h4>
                </div>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}